import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import CountryService from '../Shared/Services/CountryService';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import SweetAlertService from '../../../services/SweetAlertService';
import { countryNameMaxLength, errorMessages, getMaxLengthErrorMessage, getRequiredErrorMessage, namePattern } from '../Shared/Constants/AdminModuleConstants';

export const UpdateCountry = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { register, handleSubmit, setValue, reset, formState: { errors }, trigger } = useForm();

    useEffect(() => {
        getCountryById();
    }, []);

    const getCountryById = async () => {
        try {
            CountryService.getById(id).then((res: any) => {
                setValue('name', res.data.name);
            })
        } catch (error) {
            console.error(error);
        }
    };

    const onSubmit = (data: any) => {
        data.name = data.name.trim();
        data.id = id;
        CountryService.update(id, data).then((res) => {
            if (res) {
                navigate("/country");
            } else {
            }
            reset();
        }).catch(error => {
            if (error) {
                SweetAlertService.error("Error", error.response.data.errors.Name[0]);
            }
        })
    };
    return (
        <>
            <div className="card card-default">
                <div className="card-header">
                    <h4>Edit Country</h4>
                </div>
                <div className="card-body">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="form-group row">
                            <label className="col-sm-3 control-label">Name</label>
                            <div className="col-sm-9">
                                <input className="form-control" type="text" {...register("name", {
                                    required: getRequiredErrorMessage("Name"),
                                    pattern: {
                                        value: namePattern,
                                        message: errorMessages.pattern
                                    },
                                    maxLength: {
                                        value: countryNameMaxLength,
                                        message: getMaxLengthErrorMessage(countryNameMaxLength)
                                    }
                                })} />
                                {errors.name && <span className="help-block m-b-none text-danger field-validation-valid">{errors.name.message?.toString()}</span>}
                            </div>
                        </div>
                        <br />
                        <div className="form-group row">
                            <div className=" col-sm-offset-3">
                                <a className="btn btn-secondary" onClick={() => navigate('/country')}>Back</a>
                                <button className="btn btn-primary ms-1" type="submit">Save</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}